import request from "@/api";
import type { InformationVo } from "@zhihaoscm/entity";
import { BaseService } from "@/api/services/baseService";
import { confirmable } from "@/utils/decorator/confirmable";
import type { InformationForm, InformationQueryParam } from "@/entity/indexResearch/information";
interface InfoType {
    value: string;
    id: number | string;
}
export class InfoService extends BaseService<InformationVo, InformationVo, InformationQueryParam, InformationForm> {
    /** React 页面直接读取服务缓存，避免在 React 运行链路中引入 Vue ref。 */
    informationOptions: InfoType[] = [];
    @confirmable({
        msgs: ["是否下架", "是否上架"]
    })
    public async updateState<R>(id: number | string, state: number | string): Promise<R> {
        return this.service.post(`${this.path}/update/${id}/state/${state}`);
    }

    /**
     * 删除实例
     * @param id
     * @param unActiveFileIds
     */
    @confirmable("是否删除，删除后该砂石资讯将不再展示")
    public async delete(id: number | string, unActiveFileIds: number[] = []) {
        return this.service.delete(`${this.path}/delete`, {
            data: {
                id,
                unActiveFileIds
            }
        });
    }

    public async get(id: number | string): Promise<InformationVo> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }

    async getInform(value: string) {
        if (!value) {
            return;
        }
        // 资讯数据
        const { data } = await this.service.get(`${this.path}/selector?title=${value}`);
        this.informationOptions = data.map(({ title, id }: { title: string; id: number }) => {
            return { value: title, id: id.toString() };
        });
    }

    public async getInformDetail(id: number | string): Promise<void> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        const { id: uid, title } = data.information;
        this.informationOptions = [
            {
                value: title,
                id: uid.toString()
            }
        ];
    }
}
export const infoService = new InfoService("/dataService/admin/information", request.service);
